var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"append-to-body":true,"title":"提示","visible":_vm.dialogVisible,"width":"30%"},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('div',[_vm._l((_vm.data),function(o,index){return [_c('el-button',{key:index,on:{"click":function () {
            _vm.$emit('change', o)
            _vm.dialogVisible = false
        }}},[_vm._v(_vm._s(o))])]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }